import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpClient } from "../../lib/HttpClient";
import PaymentInfo from "./PaymentInfo";
import useEffectAsync from "../../lib/helper/useEffectAsync";
import { useLocalization } from "../../lib/localization";
import useInterval from "../../lib/helper/useInterval";
var refreshTask = null;

export default function PaymentPage() {
    const { sessionId } = useParams();
    const [item, setItem] = useState();

    const updateStatus = async () => {

        if (sessionId) {
            const paymentSession = await httpClient.Get(`/api/payment/session/${sessionId}`)
            setItem(paymentSession);
        }
    }
    useEffectAsync(updateStatus,[])
    
    useInterval(updateStatus,5000);
 
    
    return (
        <>
       { item &&
        <PaymentInfo item={item} />}
        </>
    )
}

